// JS for desktop cart drawer
let desktop_icon = document.querySelector("#cart-icon-bubble");

// Check if the current page is the cart page
if (_Template.name === "cart") {
  // Disable the click event on the cart icon
  desktop_icon.style.pointerEvents = "none";
} else {
  // Add the click event listener for other pages
  desktop_icon.addEventListener("click", function (e) {
    body.classList.remove("overflow-hidden");
  });
}